import { createStore, applyMiddleware, compose } from "redux";
import rootReducer from "./shared/combineReducers";
import thunkMiddleware from "redux-thunk";
// import { composeWithDevTools } from "redux-devtools-extension";

export default createStore(
    rootReducer,
    compose(applyMiddleware(thunkMiddleware), window.devToolsExtension ? window.devToolsExtension() : f => f),
);